import React, { useState } from 'react'
import CIcon from '@coreui/icons-react'
import { cilChevronBottom, cilChevronTop } from '@coreui/icons'
import BaseListing from 'src/BaseListings'
import { Link } from 'react-router-dom'
import { wtRoundValue } from 'src/helpers/commons/utils'
export default function VehicleTrackingReportDataTable({ reportData, FromDate, ToDate }) {
  const Base = new BaseListing()
  const [isLoading, setIsLoading] = useState(false)
  const [sortedKey, setSortedKey] = useState('')
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc',
  })
  let sumOfRatings = 0
  const sortTable = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    const sorted = [...reportData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'asc' ? -1 : 1
      }
      if (a[key] > b[key]) {
        return direction === 'asc' ? 1 : -1
      }
      return 0
    })
    setReportData(sorted)
    setSortedKey(key)
    setSortConfig({ key, direction })
  }
  const getTotalMilage = () => {
    let total = 0;
    reportData.map((item) => total += parseFloat(item.total_milage))

    return total
  }
  return (

    <>
      <table style={{}} className="table table-bordered data-table">
        <thead className="thead-dark border-dark border-1 " style={{ backgroundColor: '#e8e9eb' }}>
          <tr>
            <th onClick={() => sortTable('id')}>Sr</th>
            {/* <th>
            Device Id
            {sortedKey === 'vehicle_no' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>  */}
            <th>
              Vehicle No
              {sortedKey === 'vehicle_no' && (
                <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
              )}
            </th>
            <th>
              Make-Model
              {sortedKey === 'make' && (
                <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
              )}
            </th>
            <th>
              Registration
              {sortedKey === 'registration' && (
                <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
              )}
            </th>
            <th>
              Total Milage
              {sortedKey === 'milage' && (
                <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
              )}
            </th>
          </tr>
        </thead>
        <tbody>
          {reportData.map((item, index) => {
            return (
              <tr key={index}>
                <td className='border-1'>{index + 1}</td>
                {/* <td className='border-1'>{item.deviceid }</td> */}
                <td className='border-1'>{item.vehicle_no}</td>
                <td className='border-1'>{item.make + ' ' + item.model}</td>
                <td className='border-1'>{item.registrations}</td>
                <td className='border-1 text-primary'>
                  {item.total_milage > 0 ? (
                    <Link
                      to={{
                        pathname: '/reports',
                        search: `?deviceId=${item.deviceid}&from_date=${FromDate}&to_date=${ToDate}`,
                        hash: 'code:vehicle-tracking-details-report'
                      }}
                      target='blank'
                    >
                      {wtRoundValue(item.total_milage, 2)} KM
                    </Link>

                  ) : '0'}

                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <th colSpan={4} style={{ textAlign: 'center' }}>Total</th>
            <th>{wtRoundValue(getTotalMilage(), 2)} KM</th>
          </tr>
        </tfoot>
      </table>

    </>
  )
}
